import React from "react";
import { Row } from "./editorShared";
import { euro } from "../../lib/format";

export default function LivePreviewAside({ cur, totals }) {
  return (
    <aside className="lg:col-span-4 lg:sticky lg:top-6">
      <div className="bg-card border border-slate-200/80 rounded-xl shadow-sm overflow-hidden">
        <div className="bg-slate-900 text-white px-5 py-4">
          <p className="text-xs uppercase tracking-wider text-slate-400 font-semibold">Netto a Pagare</p>
          <p className="font-mono text-2xl font-extrabold mt-1">{euro(totals.netto, cur)}</p>
        </div>
        <div className="p-5 space-y-2.5 text-sm">
          <Row label="Imponibile servizi" value={euro(totals.imponibile, cur)} />
          {totals.scontoTotale > 0 && (
            <Row label={totals.earlyActive ? "Sconto applicato (early-bird)" : "Sconto applicato"} value={`- ${euro(totals.scontoTotale, cur)}`} muted />
          )}
          {totals.contributo > 0 && (
            <Row label={totals.contributoLabel} value={euro(totals.contributo, cur)} muted />
          )}
          {totals.ivaBreakdown.map((b) => (
            <Row key={b.rate} label={`IVA ${b.rate}%`} value={euro(b.iva, cur)} muted />
          ))}
          {totals.bollo > 0 && <Row label="Marca da bollo" value={euro(totals.bollo, cur)} muted />}
          <div className="border-t border-border pt-2.5">
            <Row label="Totale documento" value={euro(totals.totaleLordo, cur)} />
          </div>
          {totals.ritenuta > 0 && (
            <Row label={`Ritenuta d'acconto ${totals.ritenutaRate}%`} value={`- ${euro(totals.ritenuta, cur)}`} muted />
          )}
          <div className="border-t border-border pt-2.5">
            <Row label="Netto a pagare" value={euro(totals.netto, cur)} bold />
          </div>
          <div className="border-t border-border pt-3 space-y-1.5">
            <p className="text-xs uppercase tracking-wider text-slate-400 font-semibold mb-2">Rate (sul netto)</p>
            {totals.installments.map((inst, i) => (
              <Row key={i} label={inst.label} value={euro(inst.amount, cur)} muted />
            ))}
          </div>
          <div className="border-t border-border pt-3">
            <Row label="Tempistica stimata" value={`${totals.deliveryDays} giorni lavorativi`} muted />
          </div>
        </div>
      </div>
      <p data-testid="fiscal-disclaimer" className="text-[11px] text-slate-400 leading-snug mt-3 px-1">
        I calcoli fiscali (Forfettario, IVA, INPS, Cassa, Bollo e Ritenuta) sono elaborati automaticamente in base alle impostazioni del tuo profilo. Verifica sempre la correttezza del regime applicabile con il tuo consulente fiscale prima dell'emissione della fattura elettronica.
      </p>
    </aside>
  );
}
